
import jwtDecode from "jwt-decode";

let saveToken = (token) => {
    localStorage.setItem('token',token)
}

let logout = () => {
    localStorage.removeItem('token')
}

let isLogged = () => {
    let token = localStorage.getItem('token')
    return !!token
}

let isLoggedRedirect = () => {

    if (isLogged()) {
        let decodedToken = jwtDecode(localStorage.getItem('token'));
       // console.log("Decoded Token", decodedToken.exp);
        let currentDate = new Date();

        // JWT exp is in seconds
        if (decodedToken.exp * 1000 < currentDate.getTime()) {
            console.log("Token expired.");
            logout();
            window.location.replace("/blog");
        } else {
            console.log("Valid token");
            return true;
        }
    }
}

export  const accountService = {
    saveToken, logout, isLogged, isLoggedRedirect
}